<template lang="pug">
  .modals-controller
    template(v-for="modal, idx in activeModals")
      component(
        :is="modal.type"
        :key="idx"
        v-bind="modal.props"
        v-on="modal.props"
      )
</template>

<script>
import { mapGetters } from 'vuex';

import GenericController from './types/GenericController.vue';
import ConfirmController from './types/ConfirmController.vue';
import PickStaff from './types/PickStaff.vue';
import PickAvatar from './types/PickAvatar.vue';
import FormController from './types/FormController.vue';
import DialogPortal from './types/DialogPortal.vue';
import EmptyController from './types/EmptyController.vue';

export default {
  components: {
    GenericController,
    ConfirmController,
    PickStaff,
    PickAvatar,
    FormController,
    DialogPortal,
    EmptyController,
  },
  computed: {
    ...mapGetters({
      activeModals: 'modalsController/getModals',
    }),
  },
};
</script>
